import React, { useState, useEffect } from "react";
import "./Convocation.css";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import CTAButtons from "../components/sticky-button";
import BrochureForm from "../components/EnquiryForm";

const Convocation = () => {
  const [showForm, setShowForm] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  // Add your carousel images here
  const heroImages = [
    "/Convocation/MCA08741.JPG",
    "/Convocation/MCA08399.JPG",
    "/Convocation/MCA08434.JPG",

    "/Convocation/mca2.jpeg",
    "/Convocation/MCA08475.JPG",
    "/Convocation/mca1.jpeg",
    "/Convocation/MCA08511.JPG",
    "/Convocation/MCA08517.JPG",
    "/Convocation/MCA08520.JPG",
    "/Convocation/MCA08719.JPG",
    "/Convocation/MCA08720.JPG",
    "/Convocation/MCA08727.JPG",

  ];
  // Auto-scroll logic for the carousel
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev === heroImages.length - 1 ? 0 : prev + 1));
    }, 4000); // Changes image every 4 seconds
    return () => clearInterval(timer);
  }, [heroImages.length]);

  const AwardSVG = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 15L15 13V18L12 16.5L9 18V13L12 15Z" fill="currentColor" />
      <circle cx="12" cy="9" r="5" stroke="currentColor" strokeWidth="2" />
    </svg>
  );

  return (
    <div className="conv-luxury-wrapper">
      <Navbar setShowForm={setShowForm} />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButtons />

      {/* Hero Branding with Carousel */}
      <div className="conv-hero-section" style={{ position: "relative", overflow: "hidden" }}>
        {heroImages.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Convocation Hero ${index + 1}`}
            className="conv-hero-bg"
            style={{
              opacity: currentSlide === index ? 1 : 0,
              transition: "opacity 1s ease-in-out",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 0
            }}
          />
        ))}

        {/* Navigation Dots (Optional) */}
        <div style={{
          position: "absolute",
          bottom: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: "10px",
          zIndex: 2
        }}>
          {heroImages.map((_, idx) => (
            <div
              key={idx}
              onClick={() => setCurrentSlide(idx)}
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                background: currentSlide === idx ? "#fff" : "rgba(255,255,255,0.5)",
                cursor: "pointer",
                transition: "background 0.3s ease"
              }}
            />
          ))}
        </div>

        <div className="conv-hero-overlay" style={{ position: "relative", zIndex: 1 }}>
          <div className="conv-hero-badge">Home / Convocation</div>
          <div className="conv-hero-title">Convocation</div>
          <div className="conv-hero-subtitle">
            Graduation Day!! This is a much awaited event in every students life, as it gives the returns to the efforts put in by them throughout their academic endeavor. It gives a sense of achievement and a sense of responsibility towards fulfilling further commitments.
          </div>
        </div>
      </div>

      <div className="conv-content-container">
        {/* Stats Summary */}
        <div className="conv-stats-bar">
          <div className="conv-stat-block"><div className="conv-stat-val">12+</div><div className="conv-stat-lab">Academic Batches</div></div>
          <div className="conv-stat-sep"></div>
          <div className="conv-stat-block"><div className="conv-stat-val">1500+</div><div className="conv-stat-lab">Degrees Awarded</div></div>
          <div className="conv-stat-sep"></div>
          <div className="conv-stat-block"><div className="conv-stat-val">100%</div><div className="conv-stat-lab">Professional Growth</div></div>
        </div>

        <div className="conv-main-grid">

          {/* Batch 2023-2025 */}
          <div className="conv-premium-card">
            <div className="conv-card-top">
              <div className="conv-tag-row">
                <div className="conv-tag-pill">12th Convocation</div>
                <div className="conv-summary-pill">135 Graduates</div>
              </div>
              <div className="conv-batch-header">Degree Distribution for Batch 2023-2025</div>
              <div className="conv-batch-desc">
                12th Degree distribution for Batch 2023-2025 was conducted on May 2, 2026. The Guests of Honor Ms. Shilpa Pai, Sr. Vice President, Group Head HR, 3i Infotech Ltd., Mr. Amit Sinha, Sr. Manager - Data and Analytics Practice, SAP and Cloud Analytics, PwC, Alumnus Batch-2004, Mr. Hiral Mehta, Practice Head, Datamatics Global Services Ltd., Alumnus Batch-2004 graced the occasion with their presence and awarded degrees to the graduating students. First three rankers of the Batch 2023-2025 were felicitated with Memento and certificates as per the given list:
              </div>
            </div>
            <div className="conv-awards-list">
              <div className="conv-table-label">Academic Awards AY 2025-26</div>
              {[
                { r: "1", n: "Ms. Siddhi Santosh Kotre", a: "Smt. Nimnadevi Memorial Award" },
                { r: "2", n: "Mr. Jyoti Chandrakant Gupta", a: "Smt. Indradevi Memorial Award" },
                { r: "3", n: "Ms. Jayesh Milind Kolambkar", a: "Shri Shyamnarayan Singh Memorial Award" }
              ].map((item, i) => (
                <div className="conv-award-row" key={i}>
                  <div className="conv-rank-circle">{item.r}</div>
                  <div className="conv-student-info">
                    <div className="conv-student-name">{item.n}</div>
                    <div className="conv-award-name"><AwardSVG /> {item.a}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Batch 2022-2024 */}
          <div className="conv-premium-card">
            <div className="conv-card-top">
              <div className="conv-tag-row">
                <div className="conv-tag-pill">11th Convocation</div>
                <div className="conv-summary-pill">131 Graduates</div>
              </div>
              <div className="conv-batch-header">Degree Distribution for Batch 2022-2024</div>
              <div className="conv-batch-desc">
                11th Degree distribution for Batch 2022-2024 was conducted on May 2, 2025. First three rankers of the Batch 2022-2024 were felicitated with Memento and certificates as per the given list:
              </div>
            </div>
            <div className="conv-awards-list">
              <div className="conv-table-label">Academic Awards AY 2024-25</div>
              {[
                { r: "1", n: "Ms. Jinal Gala", a: "Smt. Nimnadevi Memorial Award" },
                { r: "2", n: "Ms. Muskan Akbar Ali", a: "Smt. Indradevi Memorial Award" },
                { r: "3", n: "Ms. Neelu Kewat", a: "Smt. Prabhavatidevi S. Singh Memorial Award" }
              ].map((item, i) => (
                <div className="conv-award-row" key={i}>
                  <div className="conv-rank-circle">{item.r}</div>
                  <div className="conv-student-info">
                    <div className="conv-student-name">{item.n}</div>
                    <div className="conv-award-name"><AwardSVG /> {item.a}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Batch 2021-2023 */}
          <div className="conv-premium-card">
            <div className="conv-card-top">
              <div className="conv-tag-row">
                <div className="conv-tag-pill">10th Convocation</div>
                <div className="conv-summary-pill">170 Graduates</div>
              </div>
              <div className="conv-batch-header">Degree Distribution for Batch 2021-2023</div>
              <div className="conv-batch-desc">
                Conducted on March 30, 2024. The Chief Guest <strong>Dr. Kannan M. Moudgalya</strong> (IIT Bombay), Guests of Honor <strong>Rtn. Jennifer Isaac</strong>, <strong>Dr. Sangeeta Shirname</strong>, and <strong>Ms. Vertika Chandra</strong> (Alumnus – Batch-2005) graced the occasion.
              </div>
            </div>
            <div className="conv-awards-list">
              <div className="conv-table-label">Academic Awards AY 2023-24</div>
              {[
                { r: "1", n: "Ms. Shivani Babu", a: "Smt. Nimnadevi Memorial Award" },
                { r: "2", n: "Ms. Vandana Gupta", a: "Smt. Indradevi Memorial Award" },
                { r: "3", n: "Ms. Pooja Shahu", a: "Smt. Prabhavatidevi S. Singh Memorial Award" }
              ].map((item, i) => (
                <div className="conv-award-row" key={i}>
                  <div className="conv-rank-circle">{item.r}</div>
                  <div className="conv-student-info">
                    <div className="conv-student-name">{item.n}</div>
                    <div className="conv-award-name"><AwardSVG /> {item.a}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Dual Batch 2019-2022 & 2020-2022 */}
          <div className="conv-premium-card full-width">
            <div className="conv-card-top">
              <div className="conv-tag-row">
                <div className="conv-tag-pill">9th Convocation</div>
                <div className="conv-summary-pill">297 (113+184) Graduates</div>
              </div>
              <div className="conv-batch-header">Degree Distribution for Batch 2019-2022 & Batch 2020-2022</div>
              <div className="conv-batch-desc">
                Conducted on April 21, 2023. Graced by <strong>Mr. Ravi Kajaria</strong>, <strong>Mr. Lalit Popli</strong>, <strong>Ms. Jyoti Agrawal</strong>, <strong>Ms. Anupama (Singh) Padhi</strong>, and <strong>Mr. Vishwajeet Sukhija</strong>.
              </div>
            </div>
            <div className="conv-dual-awards-grid">
              <div className="conv-mini-award-group">
                <div className="conv-table-label">Batch 2019-2022 Awards</div>
                {[{ r: "1", n: "Ms. Muskan Shaikh" }, { r: "2", n: "Ms. Mansi Naik" }, { r: "3", n: "Ms. Ankita Belel" }].map((item, i) => (
                  <div className="conv-award-row compact" key={i}><div className="conv-rank-circle">{item.r}</div><div className="conv-student-name">{item.n}</div></div>
                ))}
              </div>
              <div className="conv-mini-award-group">
                <div className="conv-table-label">Batch 2020-2022 Awards</div>
                {[{ r: "1", n: "Ms. Sandhya Santhosh" }, { r: "2", n: "Ms. Swapnali Patil" }, { r: "3", n: "Ms. Soniya Maurya" }].map((item, i) => (
                  <div className="conv-award-row compact" key={i}><div className="conv-rank-circle">{item.r}</div><div className="conv-student-name">{item.n}</div></div>
                ))}
              </div>
            </div>
          </div>

          {/* Batch 2018-2021 & 2017-2020 Grid */}
          {[
            {
              batch: "Batch 2018-2021",
              tag: "8th Degree Distribution",
              desc: "Started Feb 1, 2022. Total 117 students graduated in stipulated time. Awards were presented to top performers.",
              awards: [{ r: "1", n: "Mr. Rahul Kewat", a: "Shri Zagdu Singh Memorial Award" }, { r: "2", n: "Ms. Mayuri Tiwari", a: "Smt. Indradevi Memorial Award" }, { r: "3", n: "Mr. Mayank Kothari", a: "Shri Shyamnarayan Singh Memorial Award" }]
            },
            {
              batch: "Batch 2017-2020",
              tag: "7th Degree Distribution",
              desc: "Started March 4, 2021. Total 113 students graduated in stipulated time. Awards were presented to academic leaders.",
              awards: [{ r: "1", n: "Ms. Crina Joshi", a: "Smt. Nimnadevi Memorial Award" }, { r: "2", n: "Mr. Suraj Patel", a: "Sri. Ramnarayan Singh Memorial Award" }, { r: "3", n: "Ms. Sonia Deora", a: "Smt. Prabhavatidevi S. Singh Memorial Award" }]
            }
          ].map((sec, i) => (
            <div className="conv-premium-card" key={i}>
              <div className="conv-card-top">
                <div className="conv-tag-row"><div className="conv-tag-pill">{sec.tag}</div></div>
                <div className="conv-batch-header">{sec.batch}</div>
                <div className="conv-batch-desc">{sec.desc}</div>
              </div>
              <div className="conv-awards-list">
                {sec.awards.map((award, j) => (
                  <div className="conv-award-row" key={j}>
                    <div className="conv-rank-circle">{award.r}</div>
                    <div className="conv-student-info"><div className="conv-student-name">{award.n}</div><div className="conv-award-name">{award.a}</div></div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Archives Row */}
        <div className="conv-archive-section">
          <h2 className="conv-archive-header">Legacy & Historical Records</h2>

          <div className="conv-archive-grid">
            {[
              {
                title: "Batch 2015-2018 (5th)",
                desc: "Feb 02, 2019. Chief Guest: Mr. Suhas Mhaskar. Guests: Dr. Dhananjay Kalbande, Mr. Apurb Sinha. Total 102 Graduates.",
                awards: "1: Adithya Kanchan, 2: Anagha Patwardhan, 3: Mansi Shah",
              },
              {
                title: "Batch 2014-2017 (4th)",
                desc: "March 10, 2018. Chief Guest: Dr. Suresh Ukarande. Guests: Dr. Lavesh Jadhav, Dr. Dhananjay Kalbande. Awards started from this year. Total 92 Graduates.",
                awards: "1: Bhavika Vartak, 2: Tanmay Sakpal, 3: Anagha Baikar",
              },
              {
                title: "Batch 2016-2019",
                desc: "Conducted Dec 14, 2019. Honoring academic dedication of 109 graduates who completed in stipulated time.",
                awards: "Total 109 Graduates",
              },
              {
                title: "Batch 2013-2016 (3rd)",
                desc: "Feb 25, 2017. Dignitaries: Dr. Vivek Bhartiya (TCS), Mr. Sudhanshu Ojha (D-Link), Mr. Vikram Bansal (Tata Advanced).",
                awards: "Total 116 Graduates",
              },
              {
                title: "Batch 2012-2015",
                desc: "Feb 2016. Dignitaries: Mr. Mayur Dainait (Lupin), Dr. Rushikesh Joshi (IIT Mumbai), Mr. Durga Prasad Tiwari (Veez Capital).",
                awards: "Total 130 Graduates",
              },
            ].map((arch, i) => (
              <div className="conv-archive-card" key={i}>
                <div className="conv-arch-top">
                  <h3>{arch.title}</h3>
                </div>

                <p className="conv-arch-desc">{arch.desc}</p>

                <div className="conv-arch-footer">{arch.awards}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Convocation;